import React from 'react';
import PropTypes from 'prop-types';

export default function Capitalize({ children, transform = '' }) {
    let text = '';
    if (typeof children === 'string') {

        switch (transform) {
            case 'sentenceCase':
                text = children.slice(0, 1).toUpperCase() + children.slice(1, children.length);
                break;
            case 'startCase':
                text = children.split(" ")
                text = text.map((word) => word[0].toUpperCase() + word.substring(1)).join(" ");
                break;
            default:
                text = '';
                break;
        }
    }



    return (<>{text}</>)
}

Capitalize.protoTypes = {
    children: PropTypes.string,
    transform: PropTypes.oneOf(['sentenceCase', 'startCase'])
}